import React from 'react';
import { useTranslation } from 'react-i18next';

import IconMC from '../../../components/IconMC';
import SendPdfWithPaymentLinksContent from '../../Orders/components/payment-links/SendPdfWithPaymentLinksContent';

import { useSendPdfWithPaymentLinks } from '../../Orders/hooks/useSendPdfWithPaymentLinks';

const SendPdfWithPaymentMethods = ({
  order,
  onClose,
  onSendPdf,
  className,
}) => {
  const {
    paymentMethods,
    toggleMethod,
    handleSendPdf,
    saving
  } = useSendPdfWithPaymentLinks({ order, onClose, onSendPdf });

  return (
    <SendPdfWithPaymentLinksContent
      order={order}
      onClose={onClose}
      onSend={handleSendPdf}
      mainContainerClassName={className || "tw-p-4 tw-absolute tw-top-0 tw-right-[-300px] tw-z-[100] tw-border-t tw-border-l tw-border-gray-200 tw-bg-white tw-min-w-[300px] tw-max-w-[300px]"}
      containerClassName="tw-h-[calc(100vh-150px)]"
      header={<CustomHeader onClose={onClose} />}
      actionButton
      paymentMethods={paymentMethods}
      onToggle={toggleMethod}
      saving={saving}
    />
  );
};


const CustomHeader = ({ onClose }) => {
  const { t } = useTranslation('Inbox');

  return (
    <div className="tw-flex tw-justify-between">
      <span className="tw-font-semibold tw-text-gray-950 tw-text-sm">{t('sendPaymentLinks.sendPdfTitle')}</span>
      <IconMC
        name="close-outline"
        onClick={onClose}
      />
    </div>
  );
};

export default SendPdfWithPaymentMethods;
